import { render, staticRenderFns } from "./footer-wrapper.vue?vue&type=template&id=84a51f16&scoped=true&"
import script from "./footer-wrapper.vue?vue&type=script&lang=js&"
export * from "./footer-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./footer-wrapper.vue?vue&type=style&index=0&id=84a51f16&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a51f16",
  null
  
)

export default component.exports